import { render } from "./ProfileForm.vue?vue&type=template&id=527dea06&scoped=true"
import script from "./ProfileForm.vue?vue&type=script&lang=js"
export * from "./ProfileForm.vue?vue&type=script&lang=js"

import "./ProfileForm.vue?vue&type=style&index=0&id=527dea06&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527dea06"]])

export default __exports__